import React from 'react';
import { Button, Space, Table, Tag, Typography } from 'antd';
import { CheckCircleOutlined, ReloadOutlined } from '@ant-design/icons';
import { formatCurrency } from 'utils/number';
import { formatDate } from 'utils/date';

const { Title } = Typography;

const TIER_COLORS = {
  mien_phi: 'default',
  mini: 'blue',
  pro: 'purple',
  vip: 'gold',
};

const Desktop = ({ viewModel }) => {
  const { data, loading, approving, onApprove, reload } = viewModel;

  const columns = [
    {
      title: 'Shop',
      key: 'workspace_name',
      render: (_, record) => record?.workspace?.web_site?.title || record.w_id,
    },
    {
      title: 'Gói yêu cầu',
      dataIndex: 'package_key',
      key: 'package_key',
      render: (key, record) => (
        <Tag color={TIER_COLORS[key] || 'default'}>{record.package_name || key}</Tag>
      ),
    },
    {
      title: 'Kỳ hạn',
      dataIndex: 'duration_months',
      key: 'duration_months',
      render: (v, record) =>
        record.bonus_months > 0
          ? `${v} tháng (+${record.bonus_months} tặng)`
          : `${v} tháng`,
    },
    {
      title: 'Số tiền',
      dataIndex: 'amount',
      key: 'amount',
      render: (v) => `${formatCurrency(v)}đ`,
    },
    {
      title: 'Ngày xác nhận TT',
      dataIndex: 'payment_confirmed_on',
      key: 'payment_confirmed_on',
      render: (v) => (v ? formatDate(v) : '—'),
    },
    {
      title: 'Ghi chú TT',
      dataIndex: 'payment_note',
      key: 'payment_note',
      render: (v) => v || '—',
    },
    {
      title: 'Thao tác',
      key: 'action',
      render: (_, record) => (
        <Button
          type='primary'
          size='small'
          icon={<CheckCircleOutlined />}
          loading={approving === record.id}
          onClick={() => onApprove(record)}
        >
          Kích hoạt
        </Button>
      ),
    },
  ];

  return (
    <Space direction='vertical' size={16} style={{ width: '100%' }}>
      <Space style={{ justifyContent: 'space-between', width: '100%' }}>
        <Title level={4} style={{ margin: 0 }}>Yêu cầu nâng cấp gói</Title>
        <Button icon={<ReloadOutlined />} onClick={reload}>Làm mới</Button>
      </Space>
      <Table
        rowKey='id'
        columns={columns}
        dataSource={data}
        loading={loading}
        pagination={{ pageSize: 20 }}
      />
    </Space>
  );
};

export default Desktop;
